import _ from 'lodash'
import moment from 'moment'

export default {
  getAvailableRouteGroups (arr) {
    arr = _.uniqBy(arr, 'project_route_group')
    let groups = []
    arr.forEach(function(a) { groups.push(a.project_route_group) })
    return _.uniq(groups.sort())
  },
  getAvailableWOTypes (arr) {
    arr = _.uniqBy(arr, 'wo_type')
    let groups = []
    arr.forEach(function(a) { groups.push(a.wo_type) })
    return _.uniq(groups.sort())
  },
  getAvailableTimelines (arr) {
    arr = _.uniqBy(arr, 'timeline')
    let groups = []
    arr.forEach(function(a) { groups.push(a.timeline) })
    return _.uniq(groups.sort())
  },
  getApiObj (eventCopy, event = null, delta = null) {
    // for processing fullCalendar objects into simpler objects so the api can save/update properly.
    // eventCopy is created and passed in so that rrule can be updated (for now - this may change) 
    // event is only passed in during internal calendar moves - drag/drop and stretch.

    // just drop is handled here
    if (event && delta) {
      if (event.allDay && !eventCopy.allDay) {
        // this can only happen in week or day view
        let tempStart = moment(event.start).format('YYYY-MM-DD').toString()
        eventCopy.start = moment(tempStart + ' 00:00:00', "YYYY-MM-DD HH:mm:ss").format().toString()
      } else if (!event.allDay && eventCopy.allDay) {
        eventCopy.start = event.start
      } else {
        eventCopy.start = moment(eventCopy.start).add(delta).format('YYYY-MM-DDTHH:mm:ss').toString()
      }
  
      if (eventCopy.end) {
        if (event.allDay && !eventCopy.allDay) {
          // this can only happen in week or day view
          eventCopy.end = null
        } else if (!event.allDay && eventCopy.allDay) {
          eventCopy.end = null
        } else {
          eventCopy.end = moment(eventCopy.end).add(delta).format('YYYY-MM-DDTHH:mm:ss').toString()
        }
      }
      eventCopy.allDay = event.allDay
    }

    // this is specifically for stretch
    if (event && !delta) {
      eventCopy.start = event.start
      eventCopy.end = event.end
      eventCopy.allDay = event.allDay
    }
    

    // on drop, or save- if there's exdates, we need to adjust them by the same amount in days that the start has changed
    // now that we're using delta above, we can probably use the same here - someday.
    let oldDate = moment(eventCopy.rrule.dtstart)
    let newDate = moment(eventCopy.start)
    let diff = newDate.diff(oldDate, 'days')
    if (diff && eventCopy.exdate && eventCopy.exdate.length) {
      // console.log('exdates detected -- calling update iteration')
      // console.log("diff: ", diff, ' days (this should never be 0)' )
      // then if there's any exdate values, we iterate over the array to change them 
      eventCopy.exdate.forEach( (date, index, array) => {
        array[index] = moment(date, "YYYY-MM-DD").add(diff, 'days').format('YYYY-MM-DD')
      })
    }
    if (diff && eventCopy.rrule.until) {
      // console.log('until value detected -- calling update')
      // console.log("diff: ", diff, ' days (this should never be 0)' )
      eventCopy.rrule.until = moment(eventCopy.rrule.until).add(diff, 'days').format('YYYY-MM-DD') + 'T' + moment(eventCopy.start).format('HH:mm:ss').toString()
    }

    eventCopy.rrule.dtstart = moment(eventCopy.start).format('YYYY-MM-DDTHH:mm:ss').toString()
    if (event && event.end) {
      eventCopy.duration = moment(event.end).diff(moment(event.start))
    } else if (eventCopy.end) {
      eventCopy.duration = moment(eventCopy.end).diff(moment(eventCopy.start))
    } else {
      // if dragging from full day back to time part - need to undo duration, and unset all-day
      eventCopy.duration = null
    }
    return eventCopy
  }
}